import { z } from 'zod'

const parcelaPropostaSchema = z.object({
  data: z.string().nullish(),
  valor: z.number(),
})

export const simulacaoPropostaSchema = z.object({
  id: z.string(),
  empreendimento: z.object({
    idExterno: z.number(),
    nome: z.string(),
  }),
  valorPoupanca: z.number().nullish(),
  valorSaldo: z.number().nullish(),
  valorTotalSimulado: z.number().nullish(),
  entrada: z.array(parcelaPropostaSchema),
  mensais: z.array(
    z.object({
      parcelas: z.array(parcelaPropostaSchema),
    }),
  ),
  intermediarias: z.array(
    z.object({
      parcelas: z.array(parcelaPropostaSchema),
    }),
  ),
  posConclusao: z.array(parcelaPropostaSchema),
  saldo: parcelaPropostaSchema.nullish(),
  intermediariasPosConclusao: z
    .array(
      z.object({
        parcelas: z.array(parcelaPropostaSchema),
      }),
    )
    .nullish(),
  bloco: z.object({
    idExterno: z.number(),
    nome: z.string(),
  }),
  tipoDeAmortizacao: z.string().nullish(),
  formaDePagamento: z.string().nullish(),
  prazoEmMeses: z.number().nullish(),
})

export const produtoBaseSchema = z.object({
  idExterno: z.number(),
  codigo: z.string(),
  acessorioObrigatorio: z.boolean().nullish(),
  plantaId: z.string().nullish(),
  plantaCodigo: z.number().nullish(),
  plantaDescricao: z.string().nullish(),
  dataMarcacaoAlvenaria: z.string().nullish(),
  acessoriosDaUnidade: z
    .array(
      z.object({
        nome: z.string(),
        acessorios: z.array(
          z.object({
            idExterno: z.number(),
            nome: z.string(),
          }),
        ),
      }),
    )
    .nullish(),
})

export const simulacaoPropostaProdutoSchema = simulacaoPropostaSchema.extend({
  produto: produtoBaseSchema.extend({
    nome: z.string(),
    tipoDoProduto: z.enum(['Unidade', 'Acessorio', 'Lote']),
    andar: z.number().nullish(),
  }),
})

export type TSimulacaoProposta = z.input<typeof simulacaoPropostaSchema>
export type TSimulacaoPropostaProduto = z.input<typeof simulacaoPropostaProdutoSchema>
